import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BatchService } from '../batch.service';
import { ToastrService } from 'ngx-toastr';
import { EvsProductService } from '../../../../../common/services/EvsProduct.service';
import * as moment from 'moment';
import { ConfirmationService } from 'primeng/primeng';
import { ImageService } from '../../../../imageService';
import * as _ from 'lodash';
import { AuthBusinessService } from '../../../../../common/services/AuthBusiness.service';
import { environment } from '../../../../../../environments/environment';
import { IOption } from 'ng-select';

// import { debounceTime } from 'rxjs/operators';
declare function baseTracking(appId);

declare function visibleContent(regionName: any, contentName: any, index: any);

declare function clickTracking(regionName: any, contentName: any, target: any, payload: any);

declare function alertMsg(alertType: any, alertMessage: any);

import { TranslateService } from '@ngx-translate/core';
declare var $: any;

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styles: [``],
  styleUrls: ['./create.component.css'],
  providers: [EvsProductService, ImageService, AuthBusinessService],
})
export class CreateComponent implements OnInit {
  @Output('hideCreate') hideCreate = new EventEmitter();
  @Input() detail: any = {};
  @Input() list_prods: any = [];

  title = '';  // Translated in ngOnInit
  list_products: any = [];
  no_product = 'assets/images/no_product.png';
  no_image = 'assets/images/no-image.png';
  has_prod = false;
  prod_thumb: any = null;
  isManufacturer = '0';

  tem_chonggia = 'assets/images/tem1.png';
  tem_baohanh = 'assets/images/tem2.png';

  /*config theo server cho dễ xử lý*/
  code_chonggia = 1;
  code_baohanh = 2;
  code_tranhang = 3;
  code_dinhdanh = 5;
  // code_loyalty = 4;

  is_chonggia: any = true;
  is_baohanh: any = false;
  is_tranhang: any = false;
  is_dinhdanh: any = false;
  // is_loyalty: any = false;
  quantity: any;
  scan_by_multiple_app: any = false;
  is_show_vendor = 1;
  is_show_distributor = 1;
  counter = 1;
  counter_warning = 1;
  counter_turn;
  counter_turn_warning_bussiness;
  prefix: string = null;

  /*update batch:*/
  is_update = false;
  //status batch
  batch_not_pay = 0;
  batch_paid = 1;
  batch_activated = 2;
  is_printing = false;
  is_paid = false;
  is_batch_generate = false;
  is_prefix_generate = true;
  is_activated = false;
  has_child = false;
  has_log = false;
  messages = { success: '', warning: '', sms_success: '', sms_warning: '' };

  produce_time: any = '';
  guarantee_days = 0;
  type_guarantee_day = '';
  guarantee_days_max = 0;
  type_guarantee_day_max = '';
  guarantee_days_update = 0;
  guarantee_days_max_update = 0;
  time_alert = 0;
  time_alert_type = '';
  option_need_profile = 'not_require';
  showButton = true;
  orderType: number;
  seting_sugget: any = {
    sms: {},
    email: {},
    link: {},
    phone: {},
  };
  product: any;
  batch_sku: any;
  batch_order_code: any;
  batch_vendor_code: any;
  public user: any;
  public choice_product: any;
  public no_exist_on_seller = false;
  public FormCreateBatch: FormGroup;
  public switchAutoPrefixStamp: boolean = false;
  stampDN = 0;
  stampIS = 1;
  list_order_type_filter: Array<IOption> = [];
  public tt: any;
  public params_search_account_icheck: string;
  /* Tuanba:12/4/2022: Mekongas*/
  source = Number(JSON.parse(localStorage.getItem('User')).source)
  owner_id = Number(JSON.parse(localStorage.getItem('User')).owner_id)
  /* Tuanba:11/10/2022: Tối ưu prefix*/
  public oldPrefix: any;
  public succesPrefix: any;
  public errorPrefix: any;
  /* Tuanba: 10/7/2022: Tự động khóa tem  */
  public switchAutoLockStamp;
  public verify_scan_time: any;
  public verify_scan_time_type = ''
  public warning_scan_time: any;
  public warning_scan_time_type = ''
  public counter_scan: any;
  public radioCheckAutoStampLock = ''

  /* Tuanba: 10/7/2022: End Tự động khóa tem  */
  public isBeforeEnter: Boolean = false;
  // tslint:disable-next-line:member-ordering
  public checkAccountIcheck: any; //1: Là tài khoản tes, 2: Tài khoản bt
  countPrefixBussiness: number = 0;
  productId: any = null;
  public isCheckPrefix: boolean = false
  firstCheckMessage: number = 0;

  // === Anti-Counterfeiting v5.6: Inactive Config ===
  batch_config_inactive_active: boolean = false;
  batch_config_inactive_message: string = '';
  batch_config_inactive_contact_business: boolean = true;
  batch_config_inactive_contact_icheck: boolean = true;

  // === Anti-Counterfeiting v5.6: QRI Reminder ===
  batch_config_remind_qri_active: boolean = false;
  batch_config_remind_qri_message: string = 'Vui lòng cào lớp phủ bạc và quét mã để xác thực sản phẩm chính hãng';

  constructor(
    private fb: FormBuilder,
    private batchService: BatchService,
    private toastr: ToastrService,
    private productService: EvsProductService,
    private confirmationService: ConfirmationService,
    private imageService: ImageService,
    private connectService: AuthBusinessService,
    public translate: TranslateService
  ) {
    this.user = JSON.parse(localStorage.getItem('User'));

    this.list_order_type_filter = [
      { value: this.stampDN.toString(), label: this.translate.instant('TEM_DOANH_NGHIEP') },
      { value: this.stampIS.toString(), label: this.translate.instant('TEM_IN_SAN') },
    ];

    this.translate.onLangChange.subscribe(() => {
      this.list_order_type_filter = [
        { value: this.stampDN.toString(), label: this.translate.instant('TEM_DOANH_NGHIEP') },
        { value: this.stampIS.toString(), label: this.translate.instant('TEM_IN_SAN') },
      ];
      if (this.is_update) {
        this.title = this.translate.instant('CAP_NHAT_LO_TEM');
      } else {
        this.title = this.translate.instant('TAO_MOI_LO_TEM');
      }
    });
  }

  check() {
    if (!this.switchAutoLockStamp) {
      this.verify_scan_time = null;
      this.verify_scan_time_type = null;
      this.warning_scan_time = null;
      this.warning_scan_time_type = null
      this.counter_scan = null;
      this.radioCheckAutoStampLock = null;
      if (this.is_update) {
        this.FormCreateBatch.get('radioCheckAutoStampLock').setValue(null);
        this.FormCreateBatch.get('verify_scan_time').setValue(null);
        this.FormCreateBatch.get('verify_scan_time_type').setValue('hour');
        this.FormCreateBatch.get('warning_scan_time').setValue(null);
        this.FormCreateBatch.get('warning_scan_time_type').setValue('hour');
        this.FormCreateBatch.get('counter_scan').setValue(null);
      }

    }
  }

  resetAutoLockStamp() {
    this.radioCheckAutoStampLock = '';
    this.switchAutoLockStamp = false;
    this.verify_scan_time = null;
    this.verify_scan_time_type = ''
    this.warning_scan_time = null;
    this.warning_scan_time_type = ''
    this.counter_scan = null;
  }

  checkSpaceRemove() {
  }

  onKeyUpEventBatchVendor(event) {
    this.batch_vendor_code = event.target.value
    if (this.batch_sku === ' ' || this.batch_sku === undefined) {
      this.tt = this.batch_vendor_code;
    } else {
      this.tt = this.batch_vendor_code + this.batch_sku.slice(-3);
    }
  }

  onKeyUpEventBatchSku(event) {
    this.batch_sku = event.target.value
    this.tt = this.batch_vendor_code + this.batch_sku.slice(-3);
  }

  validateNo(e): boolean {
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false
    }
    return true
  }

  createForm() {
    let location_type = 'not_require_not_exactly';
    const radio_auto_lock_stamp = '';
    const prodId = this.detail.product_id ? this.detail.product_id.toString() : '';
    let disabled_chonggia = false;
    let disabled_baohanh = false;
    let disabled_tranhang = false;
    let disabled_dinhdanh = false;
    const disabled_loyalty = false;
    if (this.is_update) {
      let buy_services =
        this.detail && this.detail.buy_services
          ? this.detail.buy_services.split(',')
          : [];
      buy_services = _.map(buy_services, (e) => {
        return parseInt(e);
      });
      // disabled_chonggia =
      //   buy_services.indexOf(this.code_chonggia) > -1 ? false : true;
      // disabled_baohanh =
      //   buy_services.indexOf(this.code_baohanh) > -1 ? false : true;
      // disabled_tranhang =
      //   buy_services.indexOf(this.code_tranhang) > -1 ? false : true;
      // disabled_dinhdanh =
      //   buy_services.indexOf(this.code_dinhdanh) > -1 ? false : true;
      // disabled_loyalty = buy_services.indexOf(this.code_loyalty) > -1 ? false : true;
      disabled_chonggia = true;
      disabled_baohanh = true;
      disabled_tranhang = true;
      disabled_dinhdanh = true;
      location_type = this.detail.location_type;
    }
    if (this.source === 2) {
      this.FormCreateBatch = this.fb.group({
        /* Tuanba:12/4/2022: Mekongas */
        batch_order_code: [{ value: this.batch_order_code, disabled: this.is_batch_generate }, Validators.required],
        batch_vendor_code: [{ value: this.batch_vendor_code, disabled: this.is_batch_generate }, Validators.required],
        batch_sku: [{ value: this.batch_sku, disabled: this.is_batch_generate }, Validators.required],
        name: [this.detail.name ? this.detail.name : null, Validators.required],
        point: [this.detail.point],
        prefix: [
          { value: this.prefix, disabled: this.detail.order_type === 1 ? true : false },
          Validators.required,
        ],
        is_chonggia: [{ value: this.is_chonggia, disabled: disabled_chonggia }],
        is_baohanh: [{ value: this.is_baohanh, disabled: disabled_baohanh }],
        is_tranhang: [{ value: this.is_tranhang, disabled: disabled_tranhang }],
        is_dinhdanh: [{ value: this.is_dinhdanh, disabled: disabled_dinhdanh }],
        // is_loyalty: [{ value: this.is_loyalty, disabled: disabled_loyalty }],
        quantity: [
          { value: this.quantity, disabled: this.is_paid },
          Validators.required,
        ],
        scan_by_multiple_app: [this.scan_by_multiple_app],
        counter: [this.counter],
        counter_warning: [this.counter_warning],
        counter_turn: [this.counter_turn],
        counter_turn_warning_bussiness: [this.counter_turn_warning_bussiness],
        product_id: [prodId],
        produce_time: [],
        guarantee_days: [this.guarantee_days],
        type_guarantee_day: [this.type_guarantee_day],
        guarantee_days_max: [this.guarantee_days_max],
        type_guarantee_day_max: [this.type_guarantee_day_max],
        guarantee_days_update: [this.guarantee_days_update],
        guarantee_days_max_update: [this.guarantee_days_max_update],
        option_need_profile: [this.option_need_profile],
        time_alert: [this.time_alert],
        time_alert_type: [this.time_alert_type],

        // 'is_manufacturer': [null],
        show_vendor: [this.is_show_vendor],
        show_distributor: [this.is_show_distributor],
        messages: this.fb.group({
          success: [this.messages.success],
          warning: [this.messages.warning],
          sms_success: [this.messages.sms_success],
          sms_warning: [this.messages.sms_warning],
        }),
        setting_sugget: this.fb.group({
          sms: this.fb.group({
            sms_active: [this.seting_sugget.sms.sms_active],
            sms_content: [this.seting_sugget.sms.sms_content],
            sms_target: [this.seting_sugget.sms.sms_target],
            sms_title: [this.seting_sugget.sms.sms_title],
          }),
          email: this.fb.group({
            email_active: [this.seting_sugget.email.email_active],
            email_content: [this.seting_sugget.email.email_content],
            email_target: [this.seting_sugget.email.email_target],
            email_title: [this.seting_sugget.email.email_title],
          }),
          link: this.fb.group({
            link_active: [this.seting_sugget.email.link_active],
            link_content: [this.seting_sugget.email.link_content],
            link_target: [this.seting_sugget.email.link_target],
            link_title: [this.seting_sugget.email.link_title],
          }),
          phone: this.fb.group({
            phone_active: [this.seting_sugget.email.phone_active],
            phone_content: [this.seting_sugget.email.phone_content],
            phone_target: [this.seting_sugget.email.phone_target],
            phone_title: [this.seting_sugget.email.phone_title],
          }),
        }),
        active_buy_online: [this.detail.active_buy_online],
        location_type: [location_type, Validators.required],
        counter_scan: [this.counter_scan ? this.counter_scan : null],
        verify_scan_time: [this.verify_scan_time ? this.verify_scan_time : null],
        verify_scan_time_type: [this.verify_scan_time_type ? this.verify_scan_time_type : 'hour'],
        warning_scan_time: [this.warning_scan_time ? this.warning_scan_time : null],
        warning_scan_time_type: [this.warning_scan_time_type ? this.warning_scan_time_type : 'hour'],
        radioCheckAutoStampLock: [this.radioCheckAutoStampLock ? this.radioCheckAutoStampLock : null],
        code: [this.detail.code ? this.detail.code : null],
        batch_config: this.fb.group({
          inactive_config_active: [this.batch_config_inactive_active],
          inactive_message: [this.batch_config_inactive_message, [Validators.maxLength(500)]],
          inactive_contact_business: [this.batch_config_inactive_contact_business],
          inactive_contact_icheck: [this.batch_config_inactive_contact_icheck],
          remind_qri_active: [this.batch_config_remind_qri_active],
          remind_qri_message: [this.batch_config_remind_qri_message, [Validators.maxLength(255)]],
        }),
      });
    } else {
      this.FormCreateBatch = this.fb.group({
        name: [this.detail.name ? this.detail.name : null, Validators.required],
        point: [this.detail.point],
        prefix: [
          {
            value: this.prefix,
            disabled: this.is_activated || this.has_child || this.has_log || this.detail.order_type === 1 ? true : false
          },
          Validators.required,
        ],
        option: [{
          value: this.prefix,
          disabled: this.is_activated || this.has_child || this.has_log || this.detail.order_type === 1 ? true : false
        }],
        is_chonggia: [{ value: this.is_chonggia, disabled: disabled_chonggia }],
        is_baohanh: [{ value: this.is_baohanh, disabled: disabled_baohanh }],
        is_tranhang: [{ value: this.is_tranhang, disabled: disabled_tranhang }],
        is_dinhdanh: [{ value: this.is_dinhdanh, disabled: disabled_dinhdanh }],
        // is_loyalty: [{ value: this.is_loyalty, disabled: disabled_loyalty }],
        quantity: [
          { value: this.quantity, disabled: this.is_paid },
          Validators.required,
        ],
        scan_by_multiple_app: [this.scan_by_multiple_app],
        counter: [this.counter],
        counter_warning: [this.counter_warning],
        counter_turn: [this.counter_turn],
        counter_turn_warning_bussiness: [this.counter_turn_warning_bussiness],
        product_id: [prodId],
        produce_time: [],
        guarantee_days: [this.guarantee_days],
        type_guarantee_day: [this.type_guarantee_day],
        guarantee_days_max: [this.guarantee_days_max],
        type_guarantee_day_max: [this.type_guarantee_day_max],
        guarantee_days_update: [this.guarantee_days_update],
        guarantee_days_max_update: [this.guarantee_days_max_update],
        option_need_profile: [this.option_need_profile],
        time_alert: [this.time_alert],
        time_alert_type: [this.time_alert_type],

        // 'is_manufacturer': [null],
        show_vendor: [this.is_show_vendor],
        show_distributor: [this.is_show_distributor],
        messages: this.fb.group({
          success: [this.messages.success],
          warning: [this.messages.warning],
          sms_success: [this.messages.sms_success],
          sms_warning: [this.messages.sms_warning],
        }),
        setting_sugget: this.fb.group({
          sms: this.fb.group({
            sms_active: [this.seting_sugget.sms.sms_active],
            sms_content: [this.seting_sugget.sms.sms_content],
            sms_target: [this.seting_sugget.sms.sms_target],
            sms_title: [this.seting_sugget.sms.sms_title],
          }),
          email: this.fb.group({
            email_active: [this.seting_sugget.email.email_active],
            email_content: [this.seting_sugget.email.email_content],
            email_target: [this.seting_sugget.email.email_target],
            email_title: [this.seting_sugget.email.email_title],
          }),
          link: this.fb.group({
            link_active: [this.seting_sugget.email.link_active],
            link_content: [this.seting_sugget.email.link_content],
            link_target: [this.seting_sugget.email.link_target],
            link_title: [this.seting_sugget.email.link_title],
          }),
          phone: this.fb.group({
            phone_active: [this.seting_sugget.email.phone_active],
            phone_content: [this.seting_sugget.email.phone_content],
            phone_target: [this.seting_sugget.email.phone_target],
            phone_title: [this.seting_sugget.email.phone_title],
          }),
        }),
        active_buy_online: [this.detail.active_buy_online],
        location_type: [location_type, Validators.required],
        counter_scan: [this.counter_scan ? this.counter_scan : null],
        verify_scan_time: [this.verify_scan_time ? this.verify_scan_time : null],
        verify_scan_time_type: [this.verify_scan_time_type ? this.verify_scan_time_type : 'hour'],
        warning_scan_time: [this.warning_scan_time ? this.warning_scan_time : null],
        warning_scan_time_type: [this.warning_scan_time_type ? this.warning_scan_time_type : 'hour'],
        radioCheckAutoStampLock: [this.radioCheckAutoStampLock ? this.radioCheckAutoStampLock : null],
        code: [this.detail.code ? this.detail.code : null],
        batch_config: this.fb.group({
          inactive_config_active: [this.batch_config_inactive_active],
          inactive_message: [this.batch_config_inactive_message, [Validators.maxLength(500)]],
          inactive_contact_business: [this.batch_config_inactive_contact_business],
          inactive_contact_icheck: [this.batch_config_inactive_contact_icheck],
          remind_qri_active: [this.batch_config_remind_qri_active],
          remind_qri_message: [this.batch_config_remind_qri_message, [Validators.maxLength(255)]],
        }),
      });
    }

  }

  submitFormConfirm(data_post: any) {
    console.log('tuấndasdas', data_post);

    const restore_setting = {
      counter_scan: null,
      verify_scan_time: null,
      verify_scan_time_type: null,
      warning_scan_time: null,
      warning_scan_time_type: null
    }
    if (this.switchAutoLockStamp) {
      if (data_post.radioCheckAutoStampLock == 'people') {
        this.counter_scan = data_post.counter_scan
        restore_setting.counter_scan = this.counter_scan
        restore_setting.verify_scan_time = null;
        restore_setting.verify_scan_time_type = null;
        restore_setting.warning_scan_time = null;
        restore_setting.warning_scan_time_type = null;
      }
      if (data_post.radioCheckAutoStampLock == 'auth') {
        this.verify_scan_time = data_post.verify_scan_time;
        if (this.verify_scan_time == '' || this.verify_scan_time == null) {
          restore_setting.verify_scan_time = null;
          restore_setting.verify_scan_time_type = null;
        } else {
          restore_setting.verify_scan_time = data_post.verify_scan_time;
          restore_setting.verify_scan_time_type = data_post.verify_scan_time_type;
        }
        restore_setting.counter_scan = null
        restore_setting.warning_scan_time = null;
        restore_setting.warning_scan_time_type = null;
      }
      if (data_post.radioCheckAutoStampLock == 'config') {
        this.warning_scan_time = data_post.warning_scan_time;
        if (this.warning_scan_time == '' || this.warning_scan_time == null) {
          restore_setting.warning_scan_time = null;
          restore_setting.warning_scan_time_type = null;
        } else {
          restore_setting.warning_scan_time = data_post.warning_scan_time;
          restore_setting.warning_scan_time_type = data_post.warning_scan_time_type;
        }
        restore_setting.counter_scan = null
        restore_setting.verify_scan_time = null;
        restore_setting.verify_scan_time_type = null;
      }
    } else {
      data_post.restore_setting = restore_setting
    }
    const current_messages = {
      success:
        this.detail.messages && this.detail.messages.success
          ? this.detail.messages.success
          : null,
      warning:
        this.detail.messages && this.detail.messages.warning
          ? this.detail.messages.warning
          : null,
      sms_success:
        this.detail.messages && this.detail.messages.sms_success
          ? this.detail.messages.success
          : null,
      sms_warning:
        this.detail.messages && this.detail.messages.sms_warning
          ? this.detail.messages.sms_warning
          : null,
    };
    console.log('current', current_messages)
    const data: any = {};

    Object.assign(data, data_post);
    if (this.is_update && this.has_child) {
      const list_change = [];
      data.restore_setting = restore_setting
      if (data.counter && data.counter !== this.detail.counter) {
        list_change.push(this.translate.instant('SO_LAN_XAC_THUC_COLON') + data.counter);
      } else {
        delete data.counter;
      }
      if (
        data.counter_warning &&
        data.counter_warning !== this.detail.counter_warning
      ) {
        list_change.push(
          this.translate.instant('NHAN_THONG_BAO_KHI_SO_NGUOI_XAC_THUC_VUOT_QUA') +
          data.counter_warning
        );
      } else {
        delete data.counter_warning;
      }

      if (data.scan_by_multiple_app == this.detail.only_icheck) {
        if (data.scan_by_multiple_app) {
          // data.only_icheck = 0;
          list_change.push(
            this.translate.instant('UNG_DUNG_QUET_TEM_UNG_DUNG_ICHECK_VA_CAC_UNG_DUNG_KHAC')
          );
        } else {
          // data.only_icheck = 1;
          list_change.push(this.translate.instant('UNG_DUNG_QUET_TEM_CHI_QUET_BANG_UNG_DUNG_ICHECK'));
        }
      } else {
        delete data.scan_by_multiple_app;
      }

      if (data.show_vendor != this.detail.show_vendor) {
        if (data.show_vendor) {
          list_change.push(this.translate.instant('HIEN_THI_THONG_TIN_NHA_SAN_XUAT'));
        } else {
          list_change.push(this.translate.instant('KHONG_HIEN_THI_THONG_TIN_NHA_SAN_XUAT'));
        }
      } else {
        delete data.show_vendor;
      }

      if (data.show_distributor != this.detail.show_distributor) {
        if (data.show_distributor) {
          list_change.push(this.translate.instant('HIEN_THI_THONG_TIN_NHA_PHAN_PHOI'));
        } else {
          list_change.push(this.translate.instant('KHONG_HIEN_THI_THONG_TIN_NHA_PHAN_PHOI'));
        }
      } else {
        delete data.show_distributor;
      }

      if (
        data.messages &&
        typeof data.messages != 'undefined' &&
        (this.is_chonggia || this.is_baohanh) &&
        (data.messages.success != current_messages.success ||
          data.messages.warning != current_messages.warning ||
          data.messages.sms_success != current_messages.sms_success ||
          data.messages.sms_warning != current_messages.sms_warning)
      ) {
        list_change.push(this.translate.instant('THAY_OI_THONG_BAO_KHI_QUET_HOAC_NHAN_TIN_SMS'));
      } else {
        delete data.messages;
      }

      // if (list_change.length > 0) {
      //   let html = '';
      //   for (let item of list_change) {
      //     html += `<div>- ` + item + `</div>`;
      //   }
      visibleContent('qcheck_batch_update', 'form_confirm_update', '')
      this.confirmationService.confirm({
        message:
          `
                <strong>
                ` + this.translate.instant('CAC_THAY_OI_CUA_BAN_SE_UOC_AP_DUNG_CHO_TAT_CA_CAC_LO_CON_A_UOC_TACH_LO_VA_KICH_HOAT') + `
                </strong>

                `,
        header: this.translate.instant('XAC_NHAN'),
        icon: 'fa fa-warning block text-center text-warning',
        accept: () => {
          this.submitForm(data);
        },
      });

      console.log('vaof day ko ')
      // } else {
      //   this.submitForm(data);
      // }
    } else {
      console.log('vaof day ko ?')
      console.log('data', data);
      data.restore_setting = restore_setting;
      this.submitForm(data);
    }
  }

  setBuyOnline($event) {
    if (
      this.FormCreateBatch.get('active_buy_online').value &&
      this.user.seller_id
    ) {
      const barcode = this.choice_product.barcode;
      if (barcode) {
        this.connectService
          .checkBuyOnSeller(this.user.seller_id, barcode)
          .subscribe((res) => {
            this.no_exist_on_seller = !res.data ? true : false;
          });
      }
    } else {
      this.no_exist_on_seller = false;
    }
  }

  changeProduct(event) {
    this.productId = event ? event : null;
  }

  randomPrefix() {
    this.batchService
      .getRandomPrefix()
      .toPromise()
      .then((res) => {
        if (res.error == false) {
          this.prefix = res.data;
        } else {
          console.log('getRandomPrefix=error', res);
        }
      })
      .catch((err) => {
        console.log('catch getRandomPrefix', err);
      });
  }

  ngOnInit() {
    console.log('vao ko ooo???', this.detail)
    if (environment.accountBacthIcheck.includes(this.owner_id)) {
      this.checkAccountIcheck = 1;
      this.switchAutoPrefixStamp = true;
      console.log(this.checkAccountIcheck)
    } else {
      this.checkAccountIcheck = 0;
      this.switchAutoPrefixStamp = false;
      console.log(this.checkAccountIcheck)
    }
    const that = this;
    setTimeout(() => {
      const prefixBussiness = $('#prefixBussiness');
      prefixBussiness.select2({
        placeholder: this.prefix && this.checkAccountIcheck == 1 && this.is_update ? this.prefix : this.translate.instant('NHAP_TIEN_TO'),
        allowClear: true,
        ajax: {
          delay: 500,
          url: `${environment.qrcode_url_aps}/prefix`,
          headers: {
            Authorization: `Bearer ${localStorage.getItem('Access-Token')}`,
            'Content-Type': 'application/json',
          },
          dataType: 'json',
          data: function (params) {
            console.log('params11', params);
            if (params.term) {
              return {
                prefix: params.term,
                page: 1,
                pageSize: 50,
              };
            }
            return {
              page: 1,
              pageSize: 50,
            };
          },
          processResults: (data) => {
            console.log('dd', data)
            return {
              results: data.data.items.map((item) => {
                return {
                  text: item.prefix,
                  id: item.id,
                };
              }),
            };
          },
        },
      })
      //   .then(function (data) {
      //   // 16835
      //   // create the option and append to Select2
      //   console.log("ddd", data);
      //   $('#prefixBussiness').val('16835'); // Select the option with a value of '1'
      //   $('#prefixBussiness').trigger('change'); // Notify any JS components that the value changed
      //   // const option = new Option('tuan', 'ádasd', true, true);
      //   // $('#prefixBussiness').append(option).trigger('change');
      //   //
      //   // // manually trigger the `select2:select` event
      //   // $('#prefixBussiness').trigger({
      //   //   type: 'select2:select',
      //   //   params: {
      //   //     data: data
      //   //   }
      //   // });
      // });
    }, 100)

    this.has_log = this.detail.has_log;
    if (this.detail && this.detail.id > 0) {
      // this.switchAutoLockStamp = false;
      this.randomPrefixNew();
      if (this.detail.product_id > 0) {
        this.has_prod = true;
        this.productId = this.detail.product_id.toString();
        this.product = {
          value: this.detail.product_id.toString(),
          label: this.detail.product_name,
        };
      }
      this.prod_thumb = this.imageService.readSrcImage(
        this.detail.product_image,
        'thumb_medium'
      );
      this.is_update = true;
      this.title = this.translate.instant('CAP_NHAT_LO_TEM');
      let batch_status = this.detail.status;
      this.orderType = this.detail.order_type;
      if (
        batch_status == this.batch_paid ||
        batch_status == this.batch_activated
      ) {
        this.is_paid = true;
      }
      if (batch_status == this.batch_activated) {
        this.is_activated = true;
        // this.listProducts();
      }
      if (this.detail.is_printing) {
        this.is_printing = true;
      }
      this.has_child = this.detail.has_child;

      this.is_chonggia = this.detail.is_chonggia;
      this.is_baohanh = this.detail.is_baohanh;
      this.is_tranhang = this.detail.is_tranhang;
      this.is_dinhdanh = this.detail.is_dinhdanh;

      // === Load batch_config from detail (update mode) ===
      if (this.detail.batch_config) {
        let batchConfig = this.detail.batch_config;
        if (typeof batchConfig === 'string') {
          try {
            batchConfig = JSON.parse(batchConfig);
          } catch (e) {
            batchConfig = {};
          }
        }
        this.batch_config_inactive_active = batchConfig.inactive_config_active || false;
        this.batch_config_inactive_message = batchConfig.inactive_message || '';
        this.batch_config_inactive_contact_business = batchConfig.inactive_contact_business !== false;
        this.batch_config_inactive_contact_icheck = batchConfig.inactive_contact_icheck !== false;
        this.batch_config_remind_qri_active = batchConfig.remind_qri_active || false;
        this.batch_config_remind_qri_message = batchConfig.remind_qri_message || 'Vui lòng cào lớp phủ bạc và quét mã để xác thực sản phẩm chính hãng';
      }
      // === End Load batch_config ===

      this.option_need_profile = this.detail.option_need_profile;
      // this.is_loyalty = this.detail.is_loyalty;

      if (this.detail.time_alert) {
        this.time_alert = this.detail.time_alert;
      } else {
        this.time_alert = null;
      }
      if (this.detail.time_alert_type) {
        this.time_alert_type = this.detail.time_alert_type;
      } else {
        this.time_alert_type = 'months';
      }
      //===== Tự động khóa tem =====
      if (this.detail.restore_setting != undefined) {
        console.log('this.swotj', this.switchAutoLockStamp)
        if (this.detail.restore_setting.counter_scan) {
          this.counter_scan = this.detail.restore_setting.counter_scan
          this.radioCheckAutoStampLock = 'people'
          this.switchAutoLockStamp = true
          console.log('this.3', this.counter_scan)
        }
        if (this.detail.restore_setting.verify_scan_time) {
          console.log('tuándasd');
          this.verify_scan_time = this.detail.restore_setting.verify_scan_time;
          this.radioCheckAutoStampLock = 'auth'
          this.switchAutoLockStamp = true
        }
        if (this.detail.restore_setting.verify_scan_time_type) {
          this.verify_scan_time_type = this.detail.restore_setting.verify_scan_time_type;
          console.log('tuándasd');
          this.radioCheckAutoStampLock = 'auth'
          this.switchAutoLockStamp = true;
          console.log('this.3', this.switchAutoLockStamp)
        }
        if (this.detail.restore_setting.warning_scan_time) {
          this.warning_scan_time = this.detail.restore_setting.warning_scan_time;
          this.radioCheckAutoStampLock = 'config'
          this.switchAutoLockStamp = true
        }
        if (this.detail.restore_setting.warning_scan_time_type) {
          this.warning_scan_time_type = this.detail.restore_setting.warning_scan_time_type;
          this.radioCheckAutoStampLock = 'config'
          this.switchAutoLockStamp = true
          console.log('co vao koo')
        }
        if (this.detail.restore_setting.warning_scan_time == null && this.detail.restore_setting.warning_scan_time_type == null &&
          this.detail.restore_setting.verify_scan_time == null && this.detail.restore_setting.verify_scan_time_type == null &&
          this.detail.restore_setting.counter_scan == null) {
          this.resetAutoLockStamp();
        }
      } else {
        this.resetAutoLockStamp()
      }
      //===== End Tự động khóa tem =====

      if (this.detail.is_baohanh) {
        this.produce_time = this.detail.produce_time
          ? moment(this.detail.produce_time).format('DD-MM-YYYY')
          : null;

        if (!this.detail.type_guarantee_day) {
          if (this.detail.guarantee_days > 0) {
            if (this.detail.guarantee_days % 365 == 0) {
              this.guarantee_days = this.detail.guarantee_days / 365;
              this.type_guarantee_day = 'years';
            } else if (this.detail.guarantee_days % 31 == 0) {
              this.guarantee_days = this.detail.guarantee_days / 31;
              this.type_guarantee_day = 'months';
            } else {
              this.guarantee_days = this.detail.guarantee_days;
              this.type_guarantee_day = 'days';
            }
          } else {
            this.guarantee_days = null;
            this.type_guarantee_day = 'months';
          }
        } else {
          if (this.detail.guarantee_days_update > 0) {
            this.guarantee_days_update = this.detail.guarantee_days_update;
            this.type_guarantee_day = this.detail.type_guarantee_day;
          } else {
            this.guarantee_days_update = null;
            this.type_guarantee_day = 'months';
          }
        }

        if (!this.detail.type_guarantee_day_max) {
          if (this.detail.guarantee_days_max > 0) {
            if (this.detail.guarantee_days_max % 365 == 0) {
              this.guarantee_days_max = this.detail.guarantee_days_max / 365;
              this.type_guarantee_day_max = 'years';
            } else if (this.detail.guarantee_days_max % 31 == 0) {
              this.guarantee_days_max = this.detail.guarantee_days_max / 31;
              this.type_guarantee_day_max = 'months';
            } else {
              this.guarantee_days_max = this.detail.guarantee_days_max;
              this.type_guarantee_day_max = 'days';
            }
          } else {
            this.guarantee_days_max = null;
            this.type_guarantee_day_max = 'months';
          }
        } else {
          if (this.detail.guarantee_days_max > 0) {
            this.guarantee_days_max_update = this.detail.guarantee_days_max_update;
            this.type_guarantee_day_max = this.detail.type_guarantee_day_max;
          } else {
            this.guarantee_days_max_update = null;
            this.type_guarantee_day_max = 'months';
          }
        }
      }
      this.counter_turn = this.detail.counter_scan
      this.counter_turn_warning_bussiness = this.detail.counter_scan_warning
      this.prefix = this.detail.prefix;
      $('#prefixBussiness').select2('val', this.prefix);
      if (this.source === 2) {
        this.tt = this.detail.prefix;
        this.batch_order_code = this.detail.batch_order_code ? this.detail.batch_order_code : '';
        this.batch_vendor_code = this.detail.batch_vendor_code ? this.detail.batch_vendor_code : '';
        this.batch_sku = this.detail.batch_sku ? this.detail.batch_sku : '';
        this.is_batch_generate = true
      }
      this.quantity = this.detail.quantity;
      this.counter = this.detail.counter;
      this.counter_warning = this.detail.counter_warning;
      this.scan_by_multiple_app = this.detail.only_icheck ? 0 : 1;
      this.is_show_vendor = this.detail.show_vendor == 1 ? 1 : 0;
      this.is_show_distributor = this.detail.show_distributor == 1 ? 1 : 0;
      if (this.detail.messages) {
        this.messages.success = this.detail.messages.success;
        this.messages.warning = this.detail.messages.warning;
        this.messages.sms_success = this.detail.messages.sms_success;
        this.messages.sms_warning = this.detail.messages.sms_warning;
      }
      if (this.detail.suggest_apps) {
        for (let i = 0; i < this.detail.suggest_apps.length; i++) {
          switch (this.detail.suggest_apps[i].type) {
            case 'sms': {
              this.seting_sugget.sms.sms_active = true;
              this.seting_sugget.sms.sms_title = this.detail.suggest_apps[
                i
              ].title;
              this.seting_sugget.sms.sms_target = this.detail.suggest_apps[
                i
              ].target;
              this.seting_sugget.sms.sms_content = this.detail.suggest_apps[
                i
              ].content;
              break;
            }
            case 'email': {
              this.seting_sugget.email.email_active = true;
              this.seting_sugget.email.email_title = this.detail.suggest_apps[
                i
              ].title;
              this.seting_sugget.email.email_target = this.detail.suggest_apps[
                i
              ].target;
              this.seting_sugget.email.email_content = this.detail.suggest_apps[
                i
              ].content;
              break;
            }
            case 'link': {
              this.seting_sugget.link.link_active = true;
              this.seting_sugget.link.link_title = this.detail.suggest_apps[
                i
              ].title;
              this.seting_sugget.link.link_target = this.detail.suggest_apps[
                i
              ].target;
              this.seting_sugget.link.link_content = this.detail.suggest_apps[
                i
              ].content;
              break;
            }
            case 'phone': {
              this.seting_sugget.phone.phone_active = true;
              this.seting_sugget.phone.phone_title = this.detail.suggest_apps[
                i
              ].title;
              this.seting_sugget.phone.phone_target = this.detail.suggest_apps[
                i
              ].target;
              this.seting_sugget.phone.phone_content = this.detail.suggest_apps[
                i
              ].content;
              break;
            }
          }
        }
      }
    } else {
      // this.randomPrefix();
      this.randomPrefixNew();
    }
    this.createForm();
    if (this.checkAccountIcheck == 1) {
      if (this.is_activated || this.has_child || this.has_log || this.detail.order_type === 1) {
        $('#prefixBussiness').prop('disabled', true);
        $('#prefixBussiness1').click()
        $('#prefixBussiness').attr('disabled', true);
        console.log('khoa mom', $('#prefixBussiness'))
      } else {
        console.log('ko khoa mom', $('#prefixBussiness'))
        $('#prefixBussiness').prop('disabled', true);
        $('#prefixBussiness').attr('disabled', true);
      }
    }
    // this.FormCreateBatch.get('batch_vendor_code').valueChanges.pipe(debounceTime(1000)).subscribe(val => {
    //   console.log('val', val)
    // })
  }

  // listProducts() {
  //   this.productService
  //     .listProduct({ status: 1, limit: 2000 })
  //     .toPromise()
  //     .then((res: any) => {
  //       if (res.error == false) {
  //         let list: any = [];
  //         for (let prod of res.data.products) {
  //           list.push({
  //             value: "" + prod.id,
  //             label: prod.name,
  //             image: this.imageService.readSrcImage(prod.image, "thumb_medium"),
  //             barcode: prod.sku,
  //           });
  //           if (this.detail.product_id && prod.id == this.detail.product_id) {
  //             this.choice_product = {
  //               value: "" + prod.id,
  //               label: prod.name,
  //               image: this.imageService.readSrcImage(
  //                 prod.image,
  //                 "thumb_medium"
  //               ),
  //               barcode: prod.sku,
  //             };
  //           }
  //         }
  //         // this.list_products = [{value:'1',label:'1111111'},{value:'2',label:'222'},{value:'3',label:'333333'}];
  //         this.list_products = list;
  //       } else {
  //         console.log("listProduct:error", res);
  //       }
  //     })
  //     .catch((err: any) => {
  //       console.log("listProduct:error", err);
  //     });
  // }

  // isBack: true, updated:false
  backToList(data = {}) {
    this.hideCreate.emit(data);
  }

  onselect_product(event?: any) {
    this.no_exist_on_seller = false;
    this.FormCreateBatch.controls['active_buy_online'].setValue(false);
    this.has_prod = true;
    this.choice_product = event;
    this.prod_thumb = this.imageService.readSrcImage(
      event.image,
      'thumb_medium'
    );
    // this.product_selected=this.list_products.find(x=>x.value==prod_id);
  }

  insertAtCursor(ele, name, txtInsert) {
    const startPos = ele.selectionStart;
    const endPos = ele.selectionEnd;
    const str = ele.value.substring(0, startPos) + txtInsert + ele.value.substring(endPos, ele.value.length);
    ele.focus();
    ele.setSelectionRange(
      startPos + txtInsert.length,
      startPos + txtInsert.length
    );
    console.log('CheckStr', str, name)
    this.FormCreateBatch.patchValue({ messages: { [name]: str } });
    console.log(this.FormCreateBatch)
  }

  insertAtCursorForSetting(ele, name, txtInsert) {
    let startPos = ele.selectionStart;
    let endPos = ele.selectionEnd;
    let str =
      ele.value.substring(0, startPos) +
      txtInsert +
      ele.value.substring(endPos, ele.value.length);
    ele.focus();
    ele.setSelectionRange(
      startPos + txtInsert.length,
      startPos + txtInsert.length
    );
    this.FormCreateBatch.patchValue({
      setting_sugget: { sms: { [name]: str } },
    });
  }

  check_counter_warning() {
    if (!this.counter_warning) {
      this.counter_warning = this.counter;
    }
  }

  removeProduct() {
    this.FormCreateBatch.controls['active_buy_online'].setValue(false);
  }

  isNumberKey(evt) {
    const charCode = (evt.which) ? evt.which : evt.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  randomPrefixNew() {
    this.batchService
      .autoGeneratePrefix()
      .toPromise()
      .then((res) => {
        if (res.code == 1) {
          let data = {
            prefix: '',
            page: 1,
            pageSize: 10,
          }
          this.batchService.getPrefix(data).toPromise().then((val) => {
            if (res.code == 1) {
              this.countPrefixBussiness = val.data.total;
              if (this.countPrefixBussiness == 1) {
                this.prefix = val.data.items[0].prefix;
              }
            } else {
              this.countPrefixBussiness = res.data.numberOfPrefix
            }
          });
          if (!this.is_update) {
            this.prefix = res.data.prefix;
            this.checkPrefix(this.prefix)
          } else {
            this.firstCheckMessage = 1;
          }
        } else {
          this.toastr.warning(res.message, this.translate.instant('COMMON.WARNING'), {
            timeOut: 4000,
            positionClass: 'toast-top-right',
          })
        }
      })
      .catch((err) => {
        this.toastr.warning(err.message, this.translate.instant('COMMON.WARNING'), {
          timeOut: 4000,
          positionClass: 'toast-top-right',
        })
      });
  }

  randomPrefixNew2() {
    this.succesPrefix = '';
    this.errorPrefix = '';
    this.batchService
      .autoGeneratePrefix()
      .toPromise()
      .then((res) => {
        if (res.code == 1) {
          this.prefix = res.data.prefix;
          this.checkPrefix(this.prefix);
        } else {
          console.log('getRandomPrefix=error', res);
        }
      })
      .catch((err) => {
        console.log('catch getRandomPrefix', err);
      });
  }

  checkPrefix(params) {
    console.log(123123)
    this.succesPrefix = '';
    this.errorPrefix = '';
    this.batchService.checkDuplicatePrefix(params).subscribe(
      (res) => {
        if (res.code == 1 && res.data) {
          if (res.data.isValid == 1) {
            console.log(123123)
            this.succesPrefix = this.translate.instant('TIEN_TO_HOP_LE');
            this.firstCheckMessage = 1;
          } else {
            this.errorPrefix = this.translate.instant('TIEN_TO_A_TON_TAI_VUI_LONG_CHON_TIEN_TO_KHAC');
            this.firstCheckMessage = 0;
          }
        } else {
          this.errorPrefix = this.translate.instant('CO_LOI_XAY_RA');
          this.firstCheckMessage = 0;
        }
      },
      (error) => {
        this.errorPrefix = error.message
        this.firstCheckMessage = 0;
      }
    );
  }

  public submitForm(data: any) {
    const request: any = {};
    request.location_type = data.location_type;
    request.active_buy_online = data.active_buy_online || false;
    request.name = data.name;
    request.point = data.point || 0;
    request.restore_setting = data.restore_setting;
    if (request.point < 0) {
      request.point = 0;
    }
    if (this.is_update) {
      console.log('data', data);
      if (data.guarantee_days_max_update && !data.guarantee_days_update) {
        this.toastr.error(this.translate.instant('THOI_GIAN_BAO_HANH_KHONG_UOC_E_TRONG'));
        return;
      }
      // if (data.guarantee_days_max_update && !data.produce_time) {
      //   this.toastr.error(`Ngày sản xuất không được để trống`);
      //   return;
      // }
    }
    let services = '';
    // let has_chonggia =
    //   data.is_chonggia ||
    //   (this.is_update && this.is_paid && this.detail.is_chonggia);
    // let has_baohanh =
    //   data.is_baohanh ||
    //   (this.is_update && this.is_paid && this.detail.is_baohanh);
    // let has_tranhang =
    //   data.is_tranhang ||
    //   (this.is_update && this.is_paid && this.detail.is_tranhang);
    const has_chonggia = data.is_chonggia;
    const has_baohanh = data.is_baohanh;
    const has_tranhang = data.is_tranhang;
    const has_dinhdanh = data.is_dinhdanh;
    const has_loyalty = data.is_loyalty;

    if (has_chonggia && typeof data.counter !== 'undefined') {
      request.counter = data.counter;
    }
    if (has_chonggia && typeof data.counter_warning !== 'undefined') {
      request.counter_warning = data.counter_warning;
    }

    // if (has_chonggia && (!this.is_update || !this.is_paid)) {
    if (has_chonggia) {
      services +=
        services.length > 0 ? ',' + this.code_chonggia : this.code_chonggia;
    }

    // if (has_baohanh && (!this.is_update || !this.is_paid)) {
    if (has_baohanh) {
      services +=
        services.length > 0 ? ',' + this.code_baohanh : this.code_baohanh;
    }

    // if (has_tranhang && (!this.is_update || !this.is_paid)) {
    if (has_tranhang) {
      services +=
        services.length > 0 ? ',' + this.code_tranhang : this.code_tranhang;
    }
    if (has_dinhdanh) {
      services +=
        services.length > 0 ? ',' + this.code_dinhdanh : this.code_dinhdanh;
    }
    console.log('has_dinhdanh', services)

    let servicesTracking = [];
    servicesTracking = services.split(',');

    for (let i = 0; i < servicesTracking.length; i++) {
      if (servicesTracking[i] === '1') {
        servicesTracking[i] = this.translate.instant('CHONG_GIA_LOW');
      } else if (servicesTracking[i] === '2') {
        servicesTracking[i] = this.translate.instant('BAO_HANH_LOW');
      } else if (servicesTracking[i] === '3') {
        servicesTracking[i] = this.translate.instant('TRAN_HANG_LOW');
      }
      // tslint:disable-next-line:one-line
      else if (servicesTracking[i] === '5') {
        servicesTracking[i] = this.translate.instant('DINH_DANH_LOW');
      }
    }

    // if (has_loyalty) {
    //   services +=
    //     services.length > 0 ? "," + this.code_loyalty : this.code_loyalty;
    // }

    // if (typeof data.messages != 'undefined') {
    //   request.messages = null;
    //   // if (has_chonggia) {
    //   //   request.messages = data.messages;
    //   // } else {
    //   //   data.messages.sms_success = data.messages.success;
    //   //   data.messages.sms_warning = data.messages.warning;
    request.messages = data.messages;
    //   // }
    // }

    if (typeof data.show_vendor != 'undefined') {
      if (data.show_vendor == true || data.show_vendor == 1) {
        request.show_vendor = 1;
      } else {
        request.show_vendor = 0;
      }
    }

    if (typeof data.show_distributor != 'undefined') {
      if (data.show_distributor == true || data.show_distributor == 1) {
        request.show_distributor = 1;
      } else {
        request.show_distributor = 0;
      }
    }

    if (typeof data.scan_by_multiple_app !== 'undefined') {
      request.only_icheck = 1;
      if (data.scan_by_multiple_app == true) {
        request.only_icheck = 0;
      }
    }

    if (data.option_need_profile) {
      request.option_need_profile = data.option_need_profile;
    }

    if (data.time_alert) {
      request.time_alert = data.time_alert;
    }

    if (data.time_alert_type) {
      request.time_alert_type = data.time_alert_type;
    }

    if (this.is_baohanh && this.is_activated && !this.has_child) {
      request.produce_time = data.produce_time
        ? moment(data.produce_time, 'DD-MM-YYYY').format('YYYY-MM-DD')
        : null;
      // console.log(request);

      if (
        data.guarantee_days_update &&
        parseInt(data.guarantee_days_update) > 0
      ) {
        request.guarantee_days_update = data.guarantee_days_update;
        // if (data.type_guarantee_day == "days") {
        //   request.guarantee_days = data.guarantee_days;
        // } else if (data.type_guarantee_day == "years") {
        //   request.guarantee_days = parseInt(data.guarantee_days) * 365;
        // } else {
        //   request.guarantee_days = parseInt(data.guarantee_days) * 31;
        // }
      } else {
        request.guarantee_days_update = 0;
        // request.ori_guarantee_days = 0;
      }

      if (
        data.guarantee_days_max_update &&
        parseInt(data.guarantee_days_max_update) > 0
      ) {
        request.guarantee_days_max_update = data.guarantee_days_max_update;
        // if (data.type_guarantee_day_max == "days") {
        //   request.guarantee_days_max = parseInt(data.guarantee_days_max);
        // } else if (data.type_guarantee_day_max == "years") {
        //   request.guarantee_days_max = parseInt(data.guarantee_days_max) * 365;
        // } else {
        //   request.guarantee_days_max = parseInt(data.guarantee_days_max) * 31;
        // }
      } else {
        request.guarantee_days_max_update = 0;
        // request.ori_guarantee_days_max = 0;
      }
    }

    if (this.is_update && this.is_activated) {
      if (!data.product_id || data.product_id == 'null') {
        request.product_id = 0;
        // request.is_manufacturer = (data.is_manufacturer == '0' || data.is_manufacturer == '1') ? data.is_manufacturer : '1';
      } else {
        request.product_id = data.product_id;
        // request.is_manufacturer = 0;
      }
    }
    if (!this.is_update || !this.is_paid) {
      request.quantity = data.quantity;
      // if (data.is_chonggia || data.is_baohanh || data.is_tranhang) {
      //   request.services = services;
      // }
    }
    // console.log(services);
    if (data.is_chonggia || data.is_baohanh || data.is_tranhang || data.is_dinhdanh) {
      request.services = services;
    }

    if (this.source === 2 && !this.is_update) {
      request.batch_order_code = data.batch_order_code;
      request.batch_vendor_code = data.batch_vendor_code;
      request.batch_sku = data.batch_sku;
    }

    // if (!this.is_update || !(this.is_activated && !this.has_child)) {
    //   if (this.switchAutoPrefixStamp == true) {
    //     request.prefix = $('#prefixBussiness').text().trim();
    //   } else {
    //     if (data.prefix === data.prefix.trim()) {
    //       request.prefix = data.prefix.trim()
    //       console.log("tuan 2", this.switchAutoPrefixStamp)
    //     } else {
    //       this.toastr.warning('Tiền tố không được có khoảng trắng ở đầu hoặc ở cuối', "Cảnh báo");
    //       return;
    //     }
    //   }
    // }

    if (!this.is_update || this.is_update || !(this.is_activated && !this.has_child)) {
      const checkPrefixBussiness = $('#prefixBussiness option:selected').text();
      if (this.switchAutoPrefixStamp == true) {
        if (this.checkAccountIcheck == 0) {
          console.log('checkPrefixBussiness', checkPrefixBussiness)
          if (checkPrefixBussiness == '' && this.prefix == '') {
            this.toastr.warning(this.translate.instant('TIEN_TO_KHONG_UOC_E_TRONG'), this.translate.instant('COMMON.WARNING'));
            return
          } else if (checkPrefixBussiness == '' && this.prefix != '') {
            this.toastr.warning(this.translate.instant('TIEN_TO_KHONG_UOC_E_TRONG'), this.translate.instant('COMMON.WARNING'));
            return
          } else {
            request.prefix = $('#prefixBussiness option:selected').text();
          }
        } else {
          if (checkPrefixBussiness == '' && this.prefix == '') {
            this.toastr.warning(this.translate.instant('TIEN_TO_KHONG_UOC_E_TRONG'), this.translate.instant('COMMON.WARNING'));
            return
            console.log('vaso kokokokokoko', $('#prefixBussiness').text().trim(), data.prefix)
          } else if (checkPrefixBussiness == '' && data.prefix != '') {
            request.prefix = data.prefix
            console.log('bui anh tuasntrn')
          } else {
            request.prefix = $('#prefixBussiness option:selected').text();
            console.log('bui anh tuasn2')
          }
        }
      } else {
        if (data.prefix === data.prefix.trim()) {
          if (data.prefix == '') {
            this.toastr.warning(this.translate.instant('TIEN_TO_KHONG_UOC_E_TRONG'), this.translate.instant('COMMON.WARNING'));
            return
          } else {
            request.prefix = data.prefix.trim()
            console.log('tuan 2', this.switchAutoPrefixStamp)
          }
        } else {
          this.toastr.warning(this.translate.instant('TIEN_TO_KHONG_UOC_CO_KHOANG_TRANG_O_AU_HOAC_O_CUOI'), this.translate.instant('COMMON.WARNING'));
          return;
        }
      }
    }


    if (!this.is_update || !this.is_printing) {
    }

    const suggest_apps: any = [];
    if (this.seting_sugget.sms.sms_active) {
      if (
        !this.seting_sugget.sms.sms_content ||
        !this.seting_sugget.sms.sms_target ||
        !this.seting_sugget.sms.sms_title
      ) {
        this.toastr.error(this.translate.instant('DU_LIEU_CAI_AT_SMS_KHONG_UOC_E_TRONG'));
        return;
      }
      if (
        !this.seting_sugget.sms.sms_content.trim() ||
        !this.seting_sugget.sms.sms_target.trim() ||
        !this.seting_sugget.sms.sms_title.trim()
      ) {
        this.toastr.error(this.translate.instant('DU_LIEU_CAI_AT_SMS_KHONG_UOC_E_TRONG'));
        return;
      }
      suggest_apps.push({
        title: this.seting_sugget.sms.sms_title.trim(),
        target: this.seting_sugget.sms.sms_target.trim(),
        content: this.seting_sugget.sms.sms_content.trim(),
        type: 'sms',
      });
    }
    if (this.seting_sugget.email.email_active) {
      if (
        !this.seting_sugget.email.email_content ||
        !this.seting_sugget.email.email_target ||
        !this.seting_sugget.email.email_title
      ) {
        this.toastr.error(this.translate.instant('DU_LIEU_CAI_AT_EMAIL_KHONG_UOC_E_TRONG'));
        return;
      }
      if (
        !this.seting_sugget.email.email_content.trim() ||
        !this.seting_sugget.email.email_target.trim() ||
        !this.seting_sugget.email.email_title.trim()
      ) {
        this.toastr.error(this.translate.instant('DU_LIEU_CAI_AT_EMAIL_KHONG_UOC_E_TRONG'));
        return;
      }
      suggest_apps.push({
        title: this.seting_sugget.email.email_title.trim(),
        target: this.seting_sugget.email.email_target.trim(),
        content: this.seting_sugget.email.email_content.trim(),
        type: 'email',
      });
    }
    if (this.seting_sugget.link.link_active) {
      if (
        !this.seting_sugget.link.link_target ||
        !this.seting_sugget.link.link_title
      ) {
        this.toastr.error(this.translate.instant('DU_LIEU_CAI_AT_LINK_KHONG_UOC_E_TRONG'));
        return;
      }
      if (
        !this.seting_sugget.link.link_target.trim() ||
        !this.seting_sugget.link.link_title.trim()
      ) {
        this.toastr.error(this.translate.instant('DU_LIEU_CAI_AT_LINK_KHONG_UOC_E_TRONG'));
        return;
      }
      suggest_apps.push({
        title: this.seting_sugget.link.link_title.trim(),
        target: this.seting_sugget.link.link_target.trim(),
        content: null,
        type: 'link',
      });
    }
    if (this.seting_sugget.phone.phone_active) {
      if (
        !this.seting_sugget.phone.phone_target ||
        !this.seting_sugget.phone.phone_title
      ) {
        this.toastr.error(this.translate.instant('DU_LIEU_CAI_AT_PHONE_KHONG_UOC_E_TRONG'));
        return;
      }
      if (
        !this.seting_sugget.phone.phone_target.trim() ||
        !this.seting_sugget.phone.phone_title.trim()
      ) {
        this.toastr.error(this.translate.instant('DU_LIEU_CAI_AT_PHONE_KHONG_UOC_E_TRONG'));
        return;
      }
      suggest_apps.push({
        title: this.seting_sugget.phone.phone_title.trim(),
        target: this.seting_sugget.phone.phone_target.trim(),
        content: null,
        type: 'phone',
      });
    }
    if (!suggest_apps.length) {
      request.suggest_apps = null;
    } else {
      request.suggest_apps = suggest_apps;
    }

    //gan kieu d/m/y cua thoi gian bao hanh vao truong request
    if (data.type_guarantee_day) {
      request.type_guarantee_day = data.type_guarantee_day;
    }
    if (data.type_guarantee_day_max) {
      request.type_guarantee_day_max = data.type_guarantee_day_max;
    } //end gan kieu d/m/y

    if (this.productId) {
      request.product_id = this.productId;
    }
    request.counter_scan = this.counter_turn;
    request.counter_scan_warning = this.counter_turn_warning_bussiness;
    request.code = data.code != null ? data.code : '';
    // === Build batch_config for API ===
    const batchConfigData = data.batch_config;
    if (batchConfigData) {
      request.batch_config = {
        inactive_config_active: batchConfigData.inactive_config_active || false,
        inactive_message: batchConfigData.inactive_config_active ? (batchConfigData.inactive_message || '') : '',
        inactive_contact_business: batchConfigData.inactive_config_active ? batchConfigData.inactive_contact_business : true,
        inactive_contact_icheck: batchConfigData.inactive_config_active ? batchConfigData.inactive_contact_icheck : true,
        remind_qri_active: batchConfigData.remind_qri_active || false,
        remind_qri_message: batchConfigData.remind_qri_active ? (batchConfigData.remind_qri_message || '') : '',
      };
    }
    // === End batch_config ===
    console.log('request', request)
    this.showButton = false;
    // return
    if (!this.is_update) {
      console.log('request', request)
      clickTracking('qcheck_batch_detail', 'qcheck_batch_active_his', servicesTracking.toString(), 'qcheck_bacth_manage')
      this.batchService
        .createBatchStamp(request)
        .toPromise()
        .then((res: any) => {
          if (res.error == false) {
            this.backToList({ isBack: false });
            this.toastr.success(this.translate.instant('TAO_MOI_LO_TEM_THANH_CONG'), this.translate.instant('COMMON.TB'), {
              timeOut: 4000,
              positionClass: 'toast-top-right',
            });
            this.quantity = 0;
            this.firstCheckMessage = 0;
          } else {
            const mess = res.message
              ? res.message
              : this.translate.instant('TAO_MOI_LO_TEM_CHUA_THANH_CONG_VUI_LONG_THU_LAI_SAU');
            this.toastr.warning(mess, this.translate.instant('COMMON.TB'), {
              timeOut: 4000,
              positionClass: 'toast-top-right',
            });
            console.log('createBatchStamp:error', res);
            alertMsg('error', this.translate.instant('BAN_CON_LAI_SO_TEM_N_VUI_LONG_MUA_THEM_TEM_E_TAO_LO_TEM'))
          }
          this.showButton = true;

        })
        .catch((err: any) => {
          const mess = err.message
            ? err.message
            : this.translate.instant('TAO_MOI_LO_TEM_CHUA_THANH_CONG_VUI_LONG_THU_LAI_SAU');
          this.toastr.warning(mess, this.translate.instant('COMMON.TB'), {
            timeOut: 4000,
            positionClass: 'toast-top-right',
          });
          console.log('createBatchStamp:catch', err);
          alertMsg('error', this.translate.instant('BAN_CON_LAI_SO_TEM_N_VUI_LONG_MUA_THEM_TEM_E_TAO_LO_TEM'))
          this.showButton = true;

        });
    } else {
      if (this.switchAutoPrefixStamp == true) {
        if (this.checkAccountIcheck == 0) {
          const trimPrefix = $('#prefixBussiness option:selected').text();
          request.prefix = trimPrefix;
        } else {
          const checkPrefixBussiness = $('#prefixBussiness option:selected').text();
          if (checkPrefixBussiness == '' && this.prefix == '') {
            this.toastr.warning(this.translate.instant('TIEN_TO_KHONG_UOC_E_TRONG'), this.translate.instant('COMMON.WARNING'));
            return
            console.log('vaso kokokokokoko', $('#prefixBussiness').text().trim(), data.prefix)
          } else if (checkPrefixBussiness == '' && data.prefix != '') {
            request.prefix = data.prefix
            console.log('bui anh tuasntrn')
          } else {
            request.prefix = $('#prefixBussiness option:selected').text();
            console.log('bui anh tuasn2')
          }
        }
      } else {
        if (data.prefix === data.prefix.trim()) {
          request.prefix = data.prefix.trim()
        } else {
          this.toastr.warning(this.translate.instant('TIEN_TO_KHONG_UOC_CO_KHOANG_TRANG_O_AU_HOAC_O_CUOI'), this.translate.instant('COMMON.WARNING'));
          return;
        }
      }
      console.log('request', request, this.prefix)
      this.batchService
        .updateBatchStamp(this.detail.id, request)
        .toPromise()
        .then((res: any) => {
          if (res.error == false) {
            clickTracking('qcheck_batch_update', 'batch_update_submit', 'qcheck_batch_manage', '')
            this.backToList({ updated: true });
            this.firstCheckMessage = 0;
            this.toastr.success(this.translate.instant('CAP_NHAT_LO_TEM_THANH_CONG'), this.translate.instant('COMMON.TB'), {
              timeOut: 4000,
              positionClass: 'toast-top-right',
            });
          } else {
            let mess = res.message
              ? res.message
              : this.translate.instant('CAP_NHAT_LO_TEM_THANH_CONG_CHUA_THANH_CONG_VUI_LONG_THU_LAI_SAU');
            this.toastr.warning(
              mess,
              this.translate.instant('COMMON.TB'),
              {
                timeOut: 4000,
                positionClass: 'toast-top-right',
              }
            );
            console.log('updateBatchStamp:error', res);
            alertMsg('error', this.translate.instant('BAN_CON_LAI_SO_TEM_N_VUI_LONG_MUA_THEM_TEM_E_TAO_LO_TEM'));
          }
          this.showButton = true;
        })
        .catch((err: any) => {
          let mess = err.message
            ? err.message
            : this.translate.instant('CAP_NHAT_LO_TEM_THANH_CONG_CHUA_THANH_CONG_VUI_LONG_THU_LAI_SAU');
          this.toastr.warning(
            mess,
            this.translate.instant('COMMON.TB'),
            {
              timeOut: 4000,
              positionClass: 'toast-top-right',
            }
          );
          alertMsg('error', this.translate.instant('BAN_CON_LAI_SO_TEM_N_VUI_LONG_MUA_THEM_TEM_E_TAO_LO_TEM'))
          this.showButton = true;
        });
    }
    $('#prefixBussiness').text('').trigger('change');
  }

  eventSwitchAutoPrefixStamp() {
    this.firstCheckMessage = 1;
    $('#prefixBussiness').text('').trigger('change');
  }

  hasSpecialCharacter(value) {
    const regex = /[~`!@#$%^&*()_\-=\[\]{};'"\\|<>\/?`]/; // Có thể thêm hoặc loại bỏ ký tự đặc biệt theo nhu cầu
    return regex.test(value);
  }

  onBlurMethod(event, isEnter) {
    this.succesPrefix = '';
    this.errorPrefix = '';
    if (this.hasSpecialCharacter(event.target.value)) {
      this.errorPrefix = this.translate.instant('TIEN_TO_KHONG_CHUA_KY_TU_AAC_BIET');
      // this.toastr.error('Tiền tố không chứa ký tự đặc biệt', 'Thông báo:', {
      //   timeOut: 2000,
      //   positionClass: 'toast-top-right',
      // });
      event.preventDefault();
      return;
    } else {
      this.prefix = event.target.value;
      this.batchService.checkDuplicatePrefix(this.prefix).subscribe(
        (res) => {
          if (res.code == 1 && res.data) {
            if (res.data.isValid == 1) {
              this.succesPrefix = this.translate.instant('TIEN_TO_HOP_LE');
              this.firstCheckMessage = 1;
            } else {
              this.errorPrefix = this.translate.instant('TIEN_TO_A_TON_TAI_VUI_LONG_CHON_TIEN_TO_KHAC');
              this.firstCheckMessage = 0;
            }
          } else {
            this.errorPrefix = res.message
            this.firstCheckMessage = 0;
          }
        },
        (error) => {
          this.errorPrefix = error.message
          this.firstCheckMessage = 0;
        }
      );
    }
  }

  keyPressEvent(event: KeyboardEvent) {
    const specialChars = /[~`!@#$%^&*()_\-=\[\]{};'"\\|<>\/?`]/
    const inputChar = String.fromCharCode(event.charCode);
    if (specialChars.test(inputChar)) {
      console.log('abc+')
      event.preventDefault();
    }
  }

  focusEvent(event) {
    console.log('event focus', event.target.value);
    this.oldPrefix = event.target.value;
  }

  // === Anti-Counterfeiting v5.6: Toggle handlers ===
  onToggleInactiveConfig() {
    if (!this.batch_config_inactive_active) {
      this.FormCreateBatch.patchValue({
        batch_config: {
          inactive_message: '',
          inactive_contact_business: true,
          inactive_contact_icheck: true,
        }
      });
      this.batch_config_inactive_message = '';
      this.batch_config_inactive_contact_business = true;
      this.batch_config_inactive_contact_icheck = true;
    }
  }

  onToggleRemindQri() {
    if (!this.batch_config_remind_qri_active) {
      this.FormCreateBatch.patchValue({
        batch_config: {
          remind_qri_message: 'Vui lòng cào lớp phủ bạc và quét mã để xác thực sản phẩm chính hãng',
        }
      });
      this.batch_config_remind_qri_message = 'Vui lòng cào lớp phủ bạc và quét mã để xác thực sản phẩm chính hãng';
    }
  }
  // === End Toggle handlers ===

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/batchstamp/create/create.component.ts